export const en = {
    details: 'Details',
    'paid_by_the_company:': 'Paid by the company ',
    'paid_by_you:': 'You pay for ',
    'additional_services:': 'Additional services ',
};
